export const twoDigitsFormat = (n) => (n < 10 ? `0${n}` : n.toString());
